import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  saveLuckyDrawOptimRequest,
  saveLuckyDrawOptimSuccess,
  saveLuckyDrawOptimFailure,
  getLuckyDrawOptimsRequest,
  getLuckyDrawOptimsSuccess,
  getLuckyDrawOptimsFailure,
  updateLuckyDrawOptimStatusRequest,
  updateLuckyDrawOptimStatusSuccess,
  updateLuckyDrawOptimStatusFailure,
} from "./luckyDrawOptimSlice";

function* handleSaveLuckyDrawOptim(action) {
  try {
    const { body, listParams } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/saveJewellerLuckyDraw`,
      body,
    );

    if (response.data.success) {
      yield put(saveLuckyDrawOptimSuccess(response.data));
      toast.success(response.data.message || "Lucky draw saved successfully");
      yield put(getLuckyDrawOptimsRequest(listParams));
    } else {
      yield put(saveLuckyDrawOptimFailure(response.data.message));
      toast.error(response.data.message || "Failed to save lucky draw");
    }
  } catch (error) {
    yield put(saveLuckyDrawOptimFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to save lucky draw");
  }
}

function* fetchLuckyDrawOptims(action) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/getJewellerLuckyDraws`,
      { params: action.payload || {} },
    );

    yield put(getLuckyDrawOptimsSuccess(response.data));
  } catch (error) {
    yield put(getLuckyDrawOptimsFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to fetch lucky draws");
  }
}

function* updateLuckyDrawOptimStatusSaga(action) {
  try {
    const { id, optInStatus } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/updateJewellerLuckyDrawStatus/${id}`,
      { optInStatus },
    );

    if (response.data.success) {
      yield put(updateLuckyDrawOptimStatusSuccess(response.data.data));
      toast.success(response.data.message || "Status updated");
    } else {
      yield put(updateLuckyDrawOptimStatusFailure(response.data.message));
      toast.error(response.data.message || "Failed to update status");
    }
  } catch (error) {
    yield put(updateLuckyDrawOptimStatusFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to update status");
  }
}

export function* luckyDrawOptimSaga() {
  yield takeLatest(saveLuckyDrawOptimRequest.type, handleSaveLuckyDrawOptim);
  yield takeLatest(getLuckyDrawOptimsRequest.type, fetchLuckyDrawOptims);
  yield takeLatest(
    updateLuckyDrawOptimStatusRequest.type,
    updateLuckyDrawOptimStatusSaga,
  );
}
